import { useNotification } from "../context/NotificationContext";
import { useClientPrincipal } from "../context/ClientPrincipalContext";

const useURLRedirect = () => {
  const { setNotification } = useNotification();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { clientPrincipal } = useClientPrincipal();
  const userId = clientPrincipal?.userId || "";

  const handleRedirect = async (shortCode: string) => {
    try {
      const response = await fetch(`${backendUrl}/check/${shortCode}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "client-principal-user-id": userId,
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          setNotification({
            type: "error",
            message: "This URL does not exist.",
          });
        } else if (response.status === 410) {
          setNotification({ type: "error", message: "This URL is expired." });
        } else if (response.status === 500) {
          setNotification({ type: "error", message: "Server error occurred." });
        } else {
          setNotification({
            type: "error",
            message: "An unknown error occurred.",
          });
        }
        return;
      }

      const data = await response.json();
      const originalUrl = data.original_url;
      window.open(originalUrl, "_blank");
    } catch (error) {
      setNotification({
        type: "error",
        message: "Sorry, there was a problem with the redirect.",
      });
    }
  };

  return { handleRedirect };
};

export default useURLRedirect;
